/**
 * Expandable groups (used for PAGE Impact/outcomes)
 */

import React from "react";
import parse from "html-react-parser";
import { kebabCase } from "lodash";
import ExpandableGroup from "./expandable-group";
import CopyLinkButton from "./copy-link-button";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const ExpandableGroups = ({ props, annualReport }) => {
  const { backgroundColorAr: backgroundColor, columnCount, leadContent, heading, image: originalImage } = props;
  const image = originalImage?.localFile ? {
    src: originalImage?.localFile
      ? getImage(originalImage?.localFile)
      : null,
    alt: originalImage?.altText || ``,
    publicURL: originalImage?.localFile?.publicURL,
  } : null
  return (
    <section
      className={`section p-section 
      ${annualReport === "2024" ?
          (`relative  text-ar24-blue-900`) :
          annualReport === "2023" ?
            (`bg-cover ${backgroundColor === "blue" ? "bg-blue-blobs" :
              backgroundColor === "green" ? "bg-green-blobs" : backgroundColor === "gray" ? "bg-gray-blobs" :
                backgroundColor === "teal" ? "bg-teal-blobs" : "bg-white"}`)
            : (backgroundColor === "blue" ? "bg-blue-100" :
              backgroundColor === "green" ? "bg-green-100" : backgroundColor === "gray" ? "bg-gray-200" :
                backgroundColor === "teal" ? "bg-teal-50" : "bg-white")}
          `}
      key={heading || props.includeInStickyMenu?.menuTitle}
    >
      {annualReport === "2024" ? (
        <div className={`absolute top-0 left-0 w-full h-full bg-cover print:hidden ${backgroundColor === "blue" ? "bg-circles-blue opacity-20" :
          backgroundColor === "green" ? "bg-circles-green opacity-20" : backgroundColor === "gray" ? "bg-gray-200" :
            backgroundColor === "teal" ? "bg-circles-page-teal opacity-20" : "bg-white"}`} aria-hidden />
      ) : null}
      <div className="container relative ">
        <div className={`${image ? "grid grid-cols-1 lg:grid-cols-5 gap-6 items-center" : ""} ${annualReport === "2022" ? `border-l-6 pl-4 relative ${backgroundColor === "white" || backgroundColor === "blue" || backgroundColor === "mixed" ? "border-l-blue" :
          backgroundColor === "green" || backgroundColor === "gray" ? "border-l-green" :
            backgroundColor === "teal" ? "border-l-teal" : "border-l-blue"}` : ""}`}>
          <div className={`${annualReport === "2024" && !image ? "text-center mx-auto max-w-4xl" : image ? "lg:col-span-3" : "max-w-3xl"} `}>
            <div className={`group-copy-link group grid grid-cols-1 items-start justify-start`}>
              {heading ? (
                <>
                  <h2
                    className="anchor-heading leading-snug"
                    id={kebabCase(heading).replace(/[0-9]/g, '')}
                  >
                    {parse(heading)}
                  </h2>
                  <CopyLinkButton heading={heading} />
                </>
              ) : props.includeInStickyMenu?.menuTitle ? (
                <div id={kebabCase(props.includeInStickyMenu.menuTitle) || ""}>
                  <CopyLinkButton heading={props.includeInStickyMenu.menuTitle} />
                </div>
              ) : null}
              {leadContent ? (
                <div
                  className={`parsed-content mt-4 lead-content`}
                >
                  {parse(leadContent)}
                </div>
              ) : null}
            </div>
          </div>
          {image ?
            <div className="max-w-md lg:max-w-full lg:col-span-2">
              {image?.src ?
                <GatsbyImage
                  image={image.src}
                  className={`aspect-video`}
                  alt={image.alt}
                />
                : image?.publicURL ? (
                  <img
                    src={image.publicURL}
                    className={`aspect-video`}
                    alt={image.alt}
                  />
                ) : null}
            </div>
            : null}
        </div>
        <ul
          className={`mt-12 ${annualReport === "2024" ? "" : "-mx-8"} sm:mx-0 ${props.modalOrExpandable === "expandable"
            ? "divide-y divide-gray-300"
            : ""
            } gap-8 grid grid-cols-1
            ${annualReport === "2023" || annualReport === "2024" ? (columnCount === 2 ? "md:block md:masonry md:masonry-cols-2 md:space-y-8"
              : columnCount === 3 ? "md:block md:masonry md:masonry-cols-2 lg:masonry-cols-3 md:space-y-8"
                : "") : (columnCount === 2 ? "md:grid-cols-2"
                  : columnCount === 3 ? "md:grid-cols-2 lg:grid-cols-3"
                    : "")}`}
        >
          {props.groups?.map((group, index) => {
            return <ExpandableGroup group={group} index={index} annualReport={annualReport} backgroundColor={backgroundColor} columnCount={columnCount} />;
          })}
        </ul>
      </div>
    </section>
  );
};

export default ExpandableGroups;
